/*
 * -----------------------------------------------------------------------
 *  <copyright file="event.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2021 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { gql } from '@apollo/client';
import {
    EventRecordFragment,
} from './fragments';

export const SEARCH_EVENT_LOGS = gql`
    query eventLogs($startDate: Date!, $endDate: Date!, $userIds: [ObjectId!]!, $affectedUserIds: [ObjectId!]!, 
            $affectedOrganisationMemberIds: [ObjectId!]!, $userLevel: UserLevel!) {
        eventLogs(startDate: $startDate, endDate: $endDate, userIds: $userIds, affectedUserIds: $affectedUserIds, 
            affectedOrganisationMemberIds: $affectedOrganisationMemberIds, userLevel: $userLevel) {
            ...EventRecordFields
        }
    }
    ${EventRecordFragment}
`;
